import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorTitle: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-loading-error.error-title',
		defaultMessage: 'Could not load knowledge base',
		description: 'Title for when there was an error loading the knowledge base',
	},

	errorBody: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-loading-error.error-body',
		defaultMessage:
			'Please refresh and try again. If that does not work your link to Confluence might be corrupt, try re-linking it in settings.',
		description: 'Title for when there was an error loading the knowledge base',
	},

	errorCta: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-loading-error.error-cta',
		defaultMessage: 'Go to Settings',
		description: 'Title for when there was an error loading the knowledge base',
	},
});
